import React, {useEffect, useState, useRef} from 'react'
import Modal from 'react-bootstrap/Modal'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import { AlarmData, Segments, Contact } from '../Alarm Functions/AlarmOverviewFunctions'
import { Chip, Button } from '@mui/material';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, MasterDetail } from 'devextreme-react/data-grid';
import Loader from '../../Utils/Loader/NewLoader2025'
import moment, { Moment } from 'moment'
import { BackgroundColor } from 'devextreme-react/cjs/linear-gauge';
import DOMPurify from 'dompurify'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';

interface Props {
    show: boolean
    tempAlarm: AlarmData | undefined
    handleClose: () => void
}

interface HistoryData {
    dateCleared: string
    dateRecorded: string
    id: number
}

interface Notification {
    email: string
    messageSubject: string
    messageText: string
    mobile: string
    sent: string
    sentEmail: boolean
    sentSMS: boolean
    sentWhatsApp: boolean
}

const AlarmHistoryModal: React.FC<Props> = ({ show, tempAlarm, handleClose }) => {

    const intl:IntlShape = useIntl()

    const iconStyle = {
        fontSize: '22px',
    }


    ///state
    const [modalTitle, setModalTitle] = useState<string>("")
    const [triggerData, setTriggerData] = useState<HistoryData[]>()
    const [loading, setLoading] = useState<boolean>(true)
    const [notificationData, setNotificationData] = useState<Notification[]>()


    const dataGridRef = useRef(null)

    useEffect(() => {
        if (tempAlarm?.id) {
            console.log(tempAlarm?.id)
            CallGetAPI(CreateUrl(`/api/Alarms/lclAlarmHistory/${tempAlarm?.id}`), {})
                .then(data => {
                    console.log(data)
                    data = data.sort((a, b) => new Date(b.dateRecorded).getTime() - new Date(a.dateRecorded).getTime())
                    console.log(data)
                    const outputData:HistoryData[] = []
                    if (data.length > 0) {
                        data.forEach(d => {
                            const alarmHistory:HistoryData = {
                                dateCleared: d.dateCleared ? moment(d.dateCleared).format('DD-MMM-YYYY HH:mm:ss') : 'Still Active',
                                dateRecorded: moment(d.dateRecorded).format('DD-MMM-YYYY HH:mm:ss'),
                                id: d.id
                            }
                            outputData.push(alarmHistory)
                        })
                    }
                    
                    
                    setModalTitle(`${intl.formatMessage({ id: 'Alarm History for' })} ${tempAlarm?.message}`)
                    setTriggerData(outputData)
                    setLoading(false)
                })
                .catch(err => {
                    console.error(err)
                    setLoading(false)
                    setTriggerData([])
                })
        }
    }, [tempAlarm])

    const contactDetails = (intl:IntlShape):React.ReactNode => {
        return (
            <div className="alarm-history-notification-grid-wrapper">
                <DataGrid
                    dataSource={notificationData}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                >
                    <Column caption={intl.formatMessage({ id: "Recipient" })} dataField="email" />
                    <Column caption={intl.formatMessage({ id: "Mobile" })} dataField='mobile' cellRender={(d):React.ReactNode => <p>{`+${d.data.mobile}`}</p>} />
                    <Column dataField="received" caption={intl.formatMessage({ id: "Received At" })} cellRender={(data): React.ReactNode => <p>{moment(data.data.sent).format('DD MMM YYYY HH:mm:ss')}</p>} />
                    <Column cellRender={(data): React.ReactNode => renderReceivedBy(data)} width={150} caption={intl.formatMessage({ id: "Received Via" })} />
                    <Column dataField="messageSubject" caption={intl.formatMessage({id: 'Message Subject'})} />
                    <Column dataField="messageText" caption={intl.formatMessage({ id: 'Message Text' })} cellRender={(data): React.ReactNode => <div dangerouslySetInnerHTML={{ __html: data.data.messageText } }></div>} />
                </DataGrid>
            </div>
        )
    }


    const renderRecipient = (data):React.ReactNode => {
        return (
            <div
                style={{
                    display: 'flex'
                }}
            >
                <p>{data.data.email}</p>
                <p>{`+${data.data.mobile}`}</p>
            </div>
        )
    }

    const renderReceivedBy = (data): React.ReactNode => {
        const iconArr = []
        if (data.data.sentEmail) {
            iconArr.push(<i
                className="fa-solid fa-envelope"
                style={{ ...iconStyle, color: 'green'}}></i>)
        }
        if (data.data.sentWhatsApp) {
            iconArr.push(<i
                className="fa-brands fa-square-whatsapp"
                style={{ ...iconStyle, color: 'green' }}></i>)
        }
        return (
            <div style={{ display: 'flex', justifyContent: 'space-evenly', width: "100%" }}>
                {iconArr.map((i, idx) => {
                    return (
                        <div key={idx}>{i}</div>
                    )
                })}
            </div>
        )
    }

    const handleToggleDetail = (rowKey: HistoryData):void => {
        CallGetAPI(CreateUrl(`/api/Alarms/alarmReceipients?alarmId=${rowKey.id}`), {})
            .then(data => {
                data.forEach(d => {
                    d.messageText = DOMPurify.sanitize(d.messageText)
                })
                setNotificationData(data)
            })
            .catch(err => console.error(err))
        const gridInstance = dataGridRef.current?.instance();
        if (gridInstance?.isRowExpanded(rowKey)) {
            gridInstance.collapseRow(rowKey);
        } else {
            gridInstance?.expandRow(rowKey);
        }
    };

    const renderCleared = (data) => {
        if (data.value === 'Still Active') {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', color: 'red', width: '130px' }}>
                    <i className="dx-icon-warning" style={{ marginTop: 4 }}></i>
                    <p>{data.value.toUpperCase()}</p>
                    <i className="dx-icon-warning" style={{ marginTop: 4 }}></i>
                </div>
            )
        } else {
            return data.value
        }
        
    }

    return (

        <Modal
            show={show}
            style={{ transform: 'translateX(2.5vw)', position: 'absolute', zIndex: 10001 }}
            className='modal-95w'
        >
            <Modal.Header>
                <Modal.Title>
                    {modalTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading &&
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        zIndex: 13000,
                        height: 300
                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!loading && triggerData && triggerData.length > 0 && <DataGrid
                    dataSource={triggerData}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    ref={dataGridRef}
                >
                    <Column dataField="dateRecorded" caption={`${intl.formatMessage({ id: 'Date/Time of data being received into' })} ${window.location.hostname.includes('zonelog') ? 'ZONELOG' : 'Aquaguard'} `} />
                    <Column dataField="dateCleared" cellRender={(data) => renderCleared(data)} />
                    <Column cellRender={(cellInfo):React.ReactNode => (
                        <Button
                            onClick={(): void => handleToggleDetail(cellInfo.row.key)}
                            variant="contained"
                        >
                            <FormattedMessage id="View Who Received the Alarm" />
                        </Button>
                    )} />
                    <MasterDetail enabled={true} component={():React.ReactNode => contactDetails(intl)} />
                    <Column type="detailExpand" width={0} />
                </DataGrid>}
                {!loading && triggerData && triggerData?.length === 0 && <h4 style={{textAlign: 'center'} }><FormattedMessage id="No Alarm History" /></h4> }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={():void => handleClose()} variant="contained"><FormattedMessage id="Back" /></Button>
            </Modal.Footer>
        </Modal>
    )
}
export default AlarmHistoryModal